import axios from "axios";
import { Config } from "../../../core/config/config";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/parameter`;

export const parameterService = {
  saveParameterDetail: async function (params: any) {
        return axios.put(`${GATEWAY_URL}/save_parameters`, params)
        .then((response) => {
            return response.data;
        });
    },
    updateVendorSupplyParameter: async function (keys:any, params: any) {
        return axios.put(`${GATEWAY_URL}/save_parameters`, params)
        .then((response) => {
            return response.data;
        });
    }, 
    getParameterType: async function () 
    {   
        return axios.get(`${GATEWAY_URL}/type-list`,{}).then((response) => {
            return response.data;
        });
    }, 
    getParameterDetail: async function (parameterCode:any) 
    {   
        return axios.get(`${GATEWAY_URL}/detail-list?parameterCode=`+ parameterCode,)
        .then((response) => {
            return response.data;
        });
    }
 
}